/**
 * App Container.
 */

import React from 'react';
import { Container } from 'flux/utils';

import drinksStore from '../stores/drinks';
import settingsStore from '../stores/settings';
import routeStore from '../stores/route';
import { initDrinks, refreshDrinks } from '../actions/drinks';
import { initSettings } from '../actions/settings';

import App from './app';
import Splash from './splash';

const REFRESH_TIMER_SECONDS = 30;

class AppContainer extends React.Component {
  static getStores() {
    return [drinksStore, settingsStore, routeStore];
  }

  static calculateState() {
    return {
      drinks: drinksStore.getState(),
      settings: settingsStore.getState(),
      route: routeStore.getState(),
    };
  }

  constructor() {
    super();
    this.state = {
      ready: false,
    };
  }

  componentDidMount() {
    initSettings()
    .then(initDrinks)
    .then(() => {
      this.setState({
        ready: true,
      });
    });
    setInterval(refreshDrinks, REFRESH_TIMER_SECONDS * 1000);
  }

  render() {
    return this.state.ready ? <App {...this.state} /> : <Splash />;
  }
}

export default Container.create(AppContainer);



// WEBPACK FOOTER //
// ./src/components/app-container.js